<template>
    <table-component
        :parent="parent"
        :content="content"
        :config="tableConfig"
        :timestamp="timestamp"
        :selected="selected"
        :createData="createData"
        :updateBatch="updateBatch"
        :deleteData="deleteData"
        :changeUrl="changeUrl"
        :changeQuery="changeQuery"
        :query="query"
        :onCreating="onCreating"
        :onInitialized="onInitialized"
        :onSelected="onSelected"
        :addNotification="addNotification"
        ></table-component>
</template>

<script>
import V from 'voca';
import _ from 'lodash';

import TableComponent from './TableComponent';

export default {
    data() {
        return {};
    },

    props: [
        'parent', 'content', 'timestamp',
        'createData', 'updateBatch', 'deleteData',
		'changeUrl', 'changeQuery', 'query',
		'onCreating', 'onInitialized', 'onSelected',
		'addNotification', 'selected',
    ],

    components: {
        TableComponent,
    },

    watch: {

    },

    computed: {
        tableConfig() {
            const key = this.parent ? `${this.parent.type}.${this.content.type}` : this.content.type;
            return this.config(['collection', key]);
        }
    },

    mounted() {

    },

    destroyed() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/CollectionComponent.vue